import { gql } from "@outschool/ui-apollo";

const HomeQuery_FeaturedTeacher = gql`
  fragment FeaturedTeacherCard_leader on Leader {
    uid
    name
    photo
    leader_link
    details {
      headline
      headlineTranslated
    }
  }
`;

export const HomeQuery_WithNoTopics = gql`
  query HomeWithNoTopics {
    featured {
      popularTeachers {
        ...FeaturedTeacherCard_leader
      }
    }
  }
  ${HomeQuery_FeaturedTeacher}
`;
